import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/authContext";
import AppContent from "../templates/wrapper/AppContent";
import ChangeEmailForm from "../organisms/forms/changeEmail/ChangeEmailForm";
import { useToast } from "../../hooks/useToast";
import VerificationForm from "../organisms/forms/verification/VerificationForm";
import { useNavigate } from "react-router-dom";

export default function ChangeEmail() {
  const { t } = useTranslation();
  const authContext = useContext(AuthContext);
  const { showToast } = useToast();
  const navigate = useNavigate();

  const [isVerificationStage, setIsVerificationStage] = useState(false);
  const [email, setEmail] = useState("");
  const [flowType, setFlowType] = useState("");
  const [domain, setDomain] = useState("");

  const fetchSession = async () => {
    const user = await authContext.getSession();
    const email = user?.idToken.payload["email"];
    const flowType = user?.idToken.payload["custom:registration_method"];
    const domain = email?.split("@")[1];
    setFlowType(flowType);
    setDomain(domain);
  };

  useEffect(() => {
    fetchSession();
  }, []);

  const onSubmit = async (values) => {
    try {
      setEmail(values.email);
      const attr = { Name: "email", Value: values.email };
      await authContext.setAttribute(attr);
      showToast("success", t("changeProfile.transactionSuccessful"));
      setIsVerificationStage(true);
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  const handleClickVerifyWithDifferentEmail = () => {
    setIsVerificationStage(false);
  };

  const handleGetCode = async ({ otp }) => {
    try {
      await authContext.verifyAttribute(otp, "email");
      await authContext.signOut(false);
      localStorage.setItem("navigateMessage", "emailChanged");
      navigate("/");
    } catch (error) {
      if (error == "AliasExistsException: An account with the email already exists.") {
        showToast("error", t("changeEmail.emailAlreadyExists"));
      }
      else{
        showToast("error", t("changeEmail.codeErrorConfirmCode"));
      }
    }
  };

  const handleResend = async () => {
    await onSubmit({ email });
  };

  return (
    <>
      {!isVerificationStage ? (
        <AppContent title={t("home.email")}>
          <ChangeEmailForm
            flowType={flowType}
            domain={domain}
            onSubmit={onSubmit}
          />
        </AppContent>
      ) : (
        <AppContent isConfirmedPage>
          <div className="py-12">
            <VerificationForm
              title={t("emailChangeOtp.title")}
              description={t("emailChangeOtp.description")}
              handleGetCode={handleGetCode}
              handleResend={handleResend}
              handleClickVerifyWithDifferentEmail={
                handleClickVerifyWithDifferentEmail
              }
            />
          </div>
        </AppContent>
      )}
    </>
  );
}
